module.exports = __webpack_public_path__ + "static/media/data.49be868c.png";